/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { OralExamQuestionScopedRequestQuestionId } from './oralExamQuestionScopedRequestQuestionId';

/**
 * Optional question id so a stale Done/Next/reset cannot act on the wrong card.
 */
export interface OralExamQuestionScopedRequest {
  questionId?: OralExamQuestionScopedRequestQuestionId;
}
